import axios from 'axios';

const culture = document.documentElement.lang;

const apiService = {
    projects: {
        getProjects(pageId) {
            return axios.get('/Umbraco/Api/ProjectApi/GetProjects', { params: { culture, pageId } }).then(response => response);
        }
    }
};

export default apiService;
